// app/javascript/controllers/auto_submit_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 250 }
  }

  connect() {
    this._timeout = null

    // Submit immédiat sur changements simples
    this.element.addEventListener("change", this.onChange)

    // Debounce sur la saisie (recherche)
    this.element.addEventListener("input", this.onInput)

    // Tom Select émet un événement custom
    this.element.addEventListener("tom-select:change", this.onTomSelectChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange)
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("tom-select:change", this.onTomSelectChange)
    if (this._timeout) clearTimeout(this._timeout)
  }

  onChange = (event) => {
    // On ignore les inputs texte ici (gérés par debounce)
    if (event.target && event.target.matches('input[type="text"], input[type="search"]')) return
    this.submitNow()
  }

  onInput = (event) => {
    if (!event.target) return
    if (!event.target.matches('input[type="text"], input[type="search"]')) return

    if (this._timeout) clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.submitNow(), this.delayValue)
  }

  onTomSelectChange = () => {
    // TomSelect ne déclenche pas toujours un "change" natif fiable selon config,
    // donc on force la soumission ici.
    this.submitNow()
  }

  submitNow() {
    const form = this.element.closest("form") || this.element
    if (form && typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else if (form) {
      form.submit()
    }
  }
}


